import { Outlet } from "react-router-dom";

const DocumentParentPage = () => {
    return <Outlet />
}
export default DocumentParentPage;